module.exports = __webpack_public_path__ + "static/media/logoFIREBASE.5cd568b0.svg";